import { MapObjectEvent } from '../io/events'
import { Point, Rect, Size } from '../models/BasicTypes'

export interface Config {
  readonly eventHub: {
    readonly url: string
    readonly idlePeriodToPing: number
    readonly reconnectDelayMin: number
    readonly reconnectDelayMax: number
  }
  readonly mapInfo: {
    readonly dimension: Size
    readonly size: Size
  }
}

export interface Message {
  /// ID of event
  readonly eventID: string
  /// ID of user
  readonly userID: string
  /// User name to be displayed
  readonly userName: string
  /// Message content
  readonly message: string
  /// Created time of this message
  readonly createdAt: number
}

export type MapObjectType = 'image' | 'player'

export interface MapObject {
  /// ID of map object
  readonly id: string
  /// type of map object
  readonly type: MapObjectType
  /// Current position of this map object
  readonly position?: Point
}

export interface Image extends MapObject {
  /// Author name
  readonly name: string
  /// ID of user
  readonly userID: string
  /// Note
  readonly note: string
  /// Image URL
  readonly imageURL: string
  /// Normal size image URL
  readonly normalURL: string
  /// Social media size image URL
  readonly socialMediaURL: string
  /// Thumbnail URL
  readonly thumbnailURL: string
  /// Is this image loved by the user?
  readonly loved?: boolean
  /// When is this map object created
  readonly createdAt: number
}

export interface Player extends MapObject {
  /// Player display name
  readonly displayName: string
  /// ID of user
  readonly userID: string
  /// Speed of this player
  readonly speed: number
  /// When is this map object created
  readonly createdAt: number
  /// Last move event
  readonly lastMoveEvent?: {
    /// Source of move
    readonly source: Point
    /// Destination of move
    readonly destination: Point
    /// Move created at
    readonly createdAt: number
    /// Move ends at
    readonly endsAt: number
  }
}

export function isImage (mapObject: MapObject): mapObject is Image {
  return mapObject.type === 'image'
}

export function isPlayer (mapObject: MapObject): mapObject is Player {
  return mapObject.type === 'player'
}

export interface MapObjectState {
  readonly mapObject: MapObject
  /// Is this map object present?
  readonly present: boolean
  /// Is this map object data loaded?
  readonly loaded: boolean
}

export default interface WorldState {
  /// Configurations
  readonly config: Config | null
  /// Current blocks we have
  readonly blocks: Array<Point>
  /// Messages we heard so far
  readonly messages: Array<Message>
  /// Messages we are sending out
  readonly pendingMessages: Array<Message>
  /// Current player
  readonly player: Player | null
  /// MapObjects in the world
  readonly mapObjects: { [index: string]: MapObjectState }
  /// Map object events to be processed by world
  readonly events: Array<MapObjectEvent>
  /// Current view port
  readonly viewPort: Rect
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/states/WorldState.ts